<template>
  <div class="form-field">
    <label>字距</label>
    <div class="content">
      <input class="form-input" type="number" :value="wordSpace" @blur="setWordSpace($event.target.value)"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  input{
    width:83px;
  }
  .content{
    display:flex;
    >div{
      flex:1;
      margin-right:10px;
    }
    >input{
      padding:0 10px;
    }
  }
</style>

<script>
  import style from 'mixins/style'

  export default {
    mixins: [ style ],
    data() {
      return {
        value: null
      }
    },
    computed: {
      site() {
        return this.$store.state
      },
      style() {
        return this.$store.state.mask && this.$store.state.mask[ 0 ] && this.$store.state.mask[ 0 ].style || {}
      },
      mask() {
        return this.$store.state.mask && this.$store.state.mask[ 0 ]
      },
      wordSpace(){
        return (parseFloat(this.style.letterSpacing || 0)* this.site.width/this.site.rate).toFixed(0)
      }
    },
    methods: {
      resizeText(id){
        this.$store.commit('resize_element_complete', {
          id: id
        })
        this.$store.commit('set_mask', {
          id: id
        })
      },
      setWordSpace(value) {
        var id = this.mask.id
        this.updateStyle('letterSpacing', (value||0)/(this.site.width/this.site.rate)+'rem')
        this.$nextTick(() => {
          this.resizeText(id)
        })
      }
    }
  }
</script>
